<template>
    <div class="tariff-page__container">
        <TariffPagePartnerBanner v-if="isShowPartnerBanner" />
        <tariff-page-tabs
            :is-active-term-tab="isActiveTermTab"
            :on-click-tab="onClickTab"
            :tariff-percents="tariffData.percents"
        />
        <div class="comment-container" v-if="showComment">
            <div style="max-width: 75%" v-html="$t('lang.promotion.text')"></div>
        </div>
        <p v-if="hasOwner" class="p-0 m-0 text-center text-gray-800" v-html="$t('lang.pages.tariff.has_owner')"></p>
        <tariff-page-cards
            :active-term-tab-slug="activeTermTabSlug"
            :active-percent="activePercent"
            :active-ratio="activeRatio"
            :tariff-templates="tariffData.templates"
            :user="user"
            :user-tariff-id="userTariffId"
            :is-demo="isDemo"
            :locale="locale"
            :details-title-id="detailsTitleId"
            :term-relations="tariffData.termRelations"
        />
        <tariff-page-start v-if="!isUserAuthenticated" :locale="locale" />
        <tariff-page-details
            :tariff-templates="tariffData.templates"
            :details-title-id="detailsTitleId"
        />
        <tariff-page-individual-tariff />
    </div>
</template>

<script>
import {TariffTime} from "./constants/tariffTime";
import TariffPageTabs from "./component/Tabs.vue";
import TariffPageCards from "./component/Cards.vue";
import TariffPageStart from "./component/Start.vue";
import TariffPageDetails from "./component/Details.vue";
import TariffPageIndividualTariff from "./component/IndividualTariff.vue";
import TariffPagePartnerBanner from "./component/PartnerBanner.vue";
import AdaptersMessage from "../../component/adapters/Message.vue";

export default {
    name: "TariffPage",
    data() {
        return {
            activeTermTabSlug: TariffTime.ONE_MONTH,
            activePercent: 0,
            activeRatio: 1,
            detailsTitleId: 'details__title'
        }
    },
    props: {
        locale: {
            type: String,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        userTariffId: {
            type: Number,
            required: true
        },
        isDemo: {
            type: Boolean,
            required: false,
            default() {
                return false
            }
        },
        tariffData: {
            percents: Object,
            templates: Object,
            termRelations: Object
        },
        promotion: {
            type: Boolean,
            required: false,
            default: false
        },
        isShowPartnerBanner: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    computed: {
        TariffTime() {
            return TariffTime
        },
        isUserAuthenticated() {
            return this.user.id > 0;
        },
        showComment() {
            return this.promotion;
        },
        hasOwner() {
            return this.user.parent !== 0;
        },
    },
    methods: {
        isActiveTermTab(termTabSlug) {
            return this.activeTermTabSlug === termTabSlug;
        },
        onClickTab(termTabSlug, percent, ratio) {
            this.activeTermTabSlug = termTabSlug;
            this.activePercent = percent;
            this.activeRatio = Number(ratio);
        }
    },
    components: {
        AdaptersMessage,
        TariffPageTabs,
        TariffPageCards,
        TariffPageStart,
        TariffPageDetails,
        TariffPageIndividualTariff,
        TariffPagePartnerBanner,
    }
}
</script>

<style scoped>
.comment-container {
    display: flex;
    justify-content: center;
    text-align: center;
    margin: 0 auto 24px;
    font-family: Roboto,serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
}
.tariff-page__container {
    color: #232D35;
}
</style>
